module.exports = __webpack_public_path__ + "static/media/bureau_3.49036f00.png";